import React from "react";
import { MessageCircle } from "lucide-react";
import { SITE } from "../lib/data";

export default function FloatingWhatsApp() {
  const href = `https://wa.me/${SITE.whatsappIntl}?text=${encodeURIComponent(
    "Hola, me interesa más información sobre el proyecto Ariake."
  )}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Escribir a WhatsApp"
      data-testid="floating-whatsapp"
      className="fixed bottom-5 right-5 md:bottom-7 md:right-7 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[hsl(var(--hh-moss))] opacity-40 blur-xl group-hover:opacity-70 transition-opacity" />
      <span className="relative flex items-center gap-3 px-5 py-4 bg-[hsl(var(--hh-ink))] text-white border border-white/10 rounded-full shadow-2xl hover:bg-[hsl(var(--hh-moss))] transition-colors">
        <MessageCircle size={18} className="text-[hsl(var(--hh-sunrise))]" />
        <span className="overline hidden md:inline" style={{ fontSize: "0.65rem" }}>
          WhatsApp
        </span>
      </span>
    </a>
  );
}
